import { cn } from "@/lib/utils";
import { SunlowerMark } from "./SunlowerMark";

type BrandWordmarkProps = {
  className?: string;
  /** `sm` สำหรับ sidebar, `lg` สำหรับหน้า login */
  size?: "sm" | "md" | "lg";
  showSubtitle?: boolean;
  subtitle?: string;
};

const sizeStyles = {
  sm: {
    mark: "size-9",
    name: "text-xl",
    tag: "text-[9px] tracking-[0.22em]",
  },
  md: {
    mark: "size-14",
    name: "text-3xl",
    tag: "text-[10px] tracking-[0.28em]",
  },
  lg: {
    mark: "size-20",
    name: "text-4xl",
    tag: "text-xs tracking-[0.32em]",
  },
} as const;

export function BrandWordmark({
  className,
  size = "md",
  showSubtitle = true,
  subtitle = "SUPPLIES",
}: BrandWordmarkProps) {
  const s = sizeStyles[size];

  return (
    <div
      className={cn("flex flex-col items-center gap-2 text-center", className)}
    >
      <SunlowerMark className={s.mark} />
      <div className="flex flex-col items-center gap-0.5">
        <span
          className={cn("font-display font-semibold text-foreground", s.name)}
        >
          Sunlower
        </span>
        {showSubtitle ? (
          <span className="flex items-center gap-2">
            <span className="h-px w-3 bg-secondary/60" aria-hidden />
            <span
              className={cn(
                "font-sans font-semibold text-secondary uppercase",
                s.tag,
              )}
            >
              {subtitle}
            </span>
            <span className="h-px w-3 bg-secondary/60" aria-hidden />
          </span>
        ) : null}
      </div>
    </div>
  );
}
